import request from "../utils/axios";

export const getBazaars = (params) => {
  return request({ method: "GET", url: "/bazaars", params });
};

export const createBazaar = (data) => {
  return request({ method: "POST", url: "/bazaars", data });
};

export const editBazaar = (id, data) => {
  return request({ method: "PUT", url: `/bazaars/${id}`, data });
};

export const deleteBazaar = (id) => {
  return request({ method: "DELETE", url: `/bazaars/${id}` });
};

export const uploadBazaarImage = (id, data) => {
  return request({
    method: "POST",
    url: `/bazaars/${id}/images`,
    data,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteBazaarImage = (id, imageUrl) => {
  return request({ method: "DELETE", url: `/bazaars/${id}/images/${imageUrl}` });
};
